import React, { useEffect, useState } from 'react';

import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';

import { useI18n } from 'Hooks';

import Modal from './Modal';
import { AddCard, AddWrapper, CardText, CardWrapper, DeleteIconWrapper } from './styles';
import getImageUrlWithSize from '../../../utils/getResizedImage';

interface FileData {
  id: string;
  url: string;
}

export interface ImageData {
  file: FileData;
  id: string;
  title: string;
  updatedAt: string;
}

export interface Props {
  name: string;
  title?: string;
  currentImage?: ImageData;
  setImgIdForAdding: (name: string, value?: string, url?: string) => void;
}

const ImageSelect = ({ title, name, currentImage, setImgIdForAdding }: Props) => {
  const { t } = useI18n();
  const [currentImg, setCurrentImg] = useState<ImageData | null | undefined>(undefined);
  const [modalDisplaying, setModalDisplaying] = useState(false);

  const handleSelect = (value: ImageData) => {
    setCurrentImg(value);
    setImgIdForAdding(name, value.id, value.file.url);
    setModalDisplaying(false);
  };

  useEffect(() => {
    if (typeof currentImage !== 'string' || !currentImage) {
      setCurrentImg(undefined);
    }
  }, [currentImage]);

  const removeImg = () => {
    setImgIdForAdding(name, '');
    setCurrentImg(null);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key == ' ') {
      setModalDisplaying(true);
    }
  };

  const imgToUse = currentImg !== undefined ? currentImg : currentImage;

  return (
    <div>
      {modalDisplaying && (
        <Modal onSelectImg={handleSelect} onClose={() => setModalDisplaying(false)} />
      )}
      <CardWrapper>
        <AddCard
          tabIndex={0}
          withImage={!!imgToUse}
          onClick={() => setModalDisplaying(true)}
          onKeyDown={(e) => handleKeyDown}>
          {imgToUse ? (
            <img src={getImageUrlWithSize(imgToUse.file?.url, 180, 120)} alt={imgToUse.title} />
          ) : (
            <AddWrapper>
              <AddIcon />
              <CardText>{title || t('PIM.ForSelfServiceAndAppUsers')}</CardText>
            </AddWrapper>
          )}
        </AddCard>
        {imgToUse && (
          <DeleteIconWrapper onClick={removeImg}>
            <DeleteIcon htmlColor={'var(--colorBlueGray600)'} />
          </DeleteIconWrapper>
        )}
      </CardWrapper>
    </div>
  );
};

export default ImageSelect;
